import React from 'react';
import { Button } from 'semantic-ui-react';

const AddToCartButton = ({
  addToCartText,
  totalPrice,
  onAddToCart,
  disabled,
  checkoutDisabled,
}) => {
  const addToCartTextStyle = checkoutDisabled ? {} : { float: 'left' };

  return (
    <Button primary onClick={onAddToCart} disabled={disabled || checkoutDisabled}>
      <div style={addToCartTextStyle}>{addToCartText}</div>
      <div style={{ float: 'right' }}>{!checkoutDisabled && `$${totalPrice.toFixed(2)}`}</div>
    </Button>
  );
};

export default AddToCartButton;
